module.exports = __webpack_public_path__ + "images/bfb4c0810deae24d2cd7fccc0bcb7b0e.svg";